import { TransportItem } from '@grafana/faro-web-sdk';

const FARO_REDACTED_VALUE = '[REDACTED]';
const FARO_SENSITIVE_KEY_PATTERN = /authorization|cookie|pin|password|token|secret/i;

/**
 * Redacts sensitive request metadata before Faro payloads are sent to the collector.
 *
 * @param {TransportItem} transportItem - Faro transport item about to be sent.
 * @return {TransportItem | null} Sanitized item or null to drop the event.
 */
export function sanitizeFaroTransportItem(transportItem: TransportItem): TransportItem | null {
	const serializedItem = JSON.stringify(transportItem);

	if (!FARO_SENSITIVE_KEY_PATTERN.test(serializedItem)) {
		return transportItem;
	}

	const redactedItem = JSON.parse(serializedItem) as TransportItem;
	redactSensitiveValues(redactedItem);

	return redactedItem;
}

/**
 * Walks an object tree and replaces sensitive string values.
 *
 * @param {unknown} value - Current node in the transport item tree.
 * @return {void} No return value.
 */
function redactSensitiveValues(value: unknown): void {
	if (Array.isArray(value)) {
		value.forEach(redactSensitiveValues);
		return;
	}

	if (value === null || typeof value !== 'object') {
		return;
	}

	Object.entries(value as Record<string, unknown>).forEach(([key, nestedValue]) => {
		if (FARO_SENSITIVE_KEY_PATTERN.test(key) && typeof nestedValue === 'string') {
			(value as Record<string, unknown>)[key] = FARO_REDACTED_VALUE;
			return;
		}

		redactSensitiveValues(nestedValue);
	});
}
